import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { cleanReducerOnPageChange } from '../utils'
import settings from '../conf'

export const STORAGE_KEY = `forwalk-${settings.SITE_ID}-accommodation`

export const getSettings = () => {
  try {
    const data = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}
    if (data.lastAvailability) {
      data.lastAvailability.date = new Date(data.lastAvailability.date)
    }
    return data
  } catch (error) {
    return {}
  }
}

const getInitialState = () => {
  const storageSettings = getSettings()
  return {
    order: storageSettings.order || settings.USER_SETTINGS.accommodationOrder,
    lastAvailability: storageSettings.lastAvailability
  }
}

const initialState = getInitialState()

const accommodationSlice = createSlice({
  name: 'accommodation',
  initialState,
  reducers: {
    setAccommodationOrder (state, action) {
      state.order = action.payload
      localStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign(getSettings(), { order: action.payload })))
    },
    setAccommodationAvailability (state, action) {
      state.availability = action.payload
      if (action.payload) {
        state.lastAvailability = action.payload
        localStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign(getSettings(), { lastAvailability: action.payload })))
      }
    }
  },
  extraReducers: (builder) => cleanReducerOnPageChange(builder, getInitialState)
})

export const isValidAvability = (availability) => (availability && availability.date && availability.date instanceof Date && !isNaN(availability.date) && availability.date >= new Date(new Date().setHours(0, 0, 0, 0))) ? availability : null
export const useAccommodationOrder = () => useSelector(state => state.accommodation.order)
export const useAccommodationAvailability = () => useSelector(state => isValidAvability(state.accommodation.availability))
export const useLastSelectedAccomodationAvailability = () => useSelector(state => isValidAvability(state.accommodation.lastAvailability))
export const { setAccommodationOrder, setAccommodationAvailability } = accommodationSlice.actions
export default accommodationSlice
